import { getCurrentStep } from ".";
import { steps, tabs } from "../../util/constants";

export const getCurrentTab = (state) => {
  const stepToTab = {
    [steps.preview]: tabs.hotspots,
    [steps.configureLocations]: tabs.hotspots,
    [steps.configureHoverAction]: tabs.hotspots,
    [steps.configureClickAction]: tabs.hotspots,
    [steps.configurePointerText]: tabs.hotspots,
    [steps.pickTheme]: tabs.styles,
    [steps.advanced]: tabs.advanced,
  };
  const step = getCurrentStep(state);
  return stepToTab[step];
};

export const getStylesTabDisabled = (state) => {
  const step = getCurrentStep(state);
  return step === steps.configureLocations;
};

export const getAdvancedTabDisabled = (state) => {
  const step = getCurrentStep(state);
  return step === steps.configureLocations;
};

export const getHotspotsTabDisabled = (state) => {
  const step = getCurrentStep(state);
  return step === steps.configureLocations;
};
